export enum DashboardDateRangeFilter {
    NoFilter,
    Last30Days,
    CurrentMonth,
    LastMonth,
    CurrentYear,
    LastYear
}
